// extracted by mini-css-extract-plugin
export default {"templates":"TopicTemplatesPanel-module__templates--ow0Ij","emptyContainer":"TopicTemplatesPanel-module__emptyContainer--nl2st"};